/**
 * Global product popup utilities.
 * Used by Make an Offer / Contact Concierge buttons on all page types.
 */
(function() {
  var getEl = function(id) {
    return document.getElementById(id);
  };

  var getPopupBackdrop = function(id) {
    var backdropId = id + '-backdrop';
    var backdrop = getEl(backdropId);

    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = backdropId;
      backdrop.className = 'popup-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.onclick = function() {
        window.hide(id);
      };
      document.body.appendChild(backdrop);
    }

    return backdrop;
  };

  window.show = function(id) {
    var popup = getEl(id);
    if (!popup) return;

    var backdrop = getPopupBackdrop(id);
    popup.classList.add('is-open');
    backdrop.classList.add('is-open');
    backdrop.style.display = 'block';
    popup.style.display = 'block';
    document.body.classList.add('popup-open');
  };

  window.hide = function(id) {
    var popup = getEl(id);
    var backdrop = getEl(id + '-backdrop');

    if (popup) {
      popup.classList.remove('is-open');
      popup.style.display = 'none';
    }
    if (backdrop) {
      backdrop.classList.remove('is-open');
      backdrop.style.display = 'none';
    }

    if (!document.querySelector('.popup.is-open, .popup[style*="display: block"], .popup[style*="display:block"]')) {
      document.body.classList.remove('popup-open');
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    var params = new URLSearchParams(window.location.search);

    if (params.get('open_offer') === '1') {
      window.setTimeout(function() {
        window.show('popup');
      }, 600);
    }

    if (params.get('open_concierge') === '1') {
      window.setTimeout(function() {
        window.show('contact-concierge-popup');
      }, 600);
    }
  });
})();
